import React from "react";
export default function Preloader() {
  return (
    <div className="preloader">
      <div className="sk-rotating-plane"></div>
    </div>
  );
}
